import { useTranslation } from "react-i18next";
import Page from "../../components/PageContainer/Page";
import Gallery from "../../components/common/Gallery/Gallery";
import SectionDivider from "../../components/common/SectionDivider/SectionDivider";
import styles from "./Gallery.module.scss";
import AnimatedWrapper from "../../components/common/AnimatedWrapper/AnimatedWrapper";

const GalleryPage = () => {
  const { t } = useTranslation();

  return (
    <Page name="gallery" background="white">
      <div className={styles.galleryPage}>
        <div className={styles.galleryPage__header}>
          <AnimatedWrapper>
            <h2 className={styles.galleryPage__title}>{t('gallery.title')}</h2>
          </AnimatedWrapper>
          <AnimatedWrapper>
            <SectionDivider />
          </AnimatedWrapper>
          <AnimatedWrapper>
            <p className={styles.galleryPage__subtitle}>
              {t('gallery.subtitle')}
            </p>
          </AnimatedWrapper>
        </div>

        <div className={styles.galleryPage__content}>
          <Gallery />
        </div>
      </div>
    </Page>
  );
};

export default GalleryPage; 